export default class QueryParamEncoder {

    static encodeObjectToArray(queryParams, paramKey) {
        const params = new URLSearchParams();

        for (const key in queryParams) {
            const value = queryParams[key];
            const encodedKey = `${paramKey}[${encodeURIComponent(key)}]`;

            if (Array.isArray(value) && value.length === 0 || value === null) {
                continue;
            }

            if (Array.isArray(value)) {
                value.forEach(v => params.append(`${encodedKey}[]`, v));
            } else {
                params.append(encodedKey, value);
            }
        }
        return params.toString();
    }

    static encodeArray(array, paramKey) {
        const params = new URLSearchParams();
        if (Array.isArray(array) && array.length > 0) {
            array.forEach(value => params.append(`${paramKey}[]`, value));
        }
        return params.toString();
    }
}
